export default __webpack_public_path__ + "static/media/53t.8cfb0156.jpg";